import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { Router } from '@angular/router';

@Component({
  selector: 'credentials',
  template: require('./credentials.component.html')
})

export class CredentialsComponent extends BaseRoute {

  constructor(injector: Injector, router: Router) {
    super(injector);
    this.credError = true;
    this.error = true;
    this.router = router;
  }

  ngOnInit() {
    this.hasACHProfile = this.flowManager.hasACHProfile;
    this.hasManualACHProfile = this.flowManager.hasManualACHProfile;
    this.hasFundedAccount = this.flowManager.hasFundedAccount;

    // Conditional logic to show Back Button
    if (!this.hasFundedAccount && !this.hasManualACHProfile) {
      this.form.buttons.inputs.back.classes = 'btn-secondary';
      if (this.hasACHProfile) { // ACH Profile has been created but didn't deposit funds
        this.goBackURL = '/deposit-funds';
      } else { // No Plaid or manual ACH Profile has been created
        this.goBackURL = '/funding-choices';
      }
    } else {
      this.goBackURL = null;
    }
  }

  updateBtnClicked(e) {
    if (e.action === 'next') {
      const credentialData = this.appActions.getData('Credentials');
      this.modal.loadingModel();

      const payload = {
        customerUsername: credentialData.Credentials_Username,
        customerPassword: credentialData.Credentials_Password,
        customerConfirmPassword: credentialData.Credentials_Confirm_Password,
        passwordHint: credentialData.Credentials_Password_Hint,
      };

      this.credError = true;
      this.error = true;

      this.flowManager.isSubmitting = true;
      this.appProxy.identityCreateUser(payload, res => this.createUserResponse(res));
    } else if (e.action === 'back') {
      if (this.goBackURL) this.router.navigate([this.goBackURL]);
    }
  }

  createUserResponse(res) {
    // Check for errors 1st!!!!
    if (res.status === 500 || !res.cupid) {
      this.modal.refreshModal({
        modalType: 'nonClosable',
        fukTopRight: 'false',
        modalClass: 'pending-modal',
        title: 'Error while creating credentials.',
        body: `<div class="modal-font-weight">This service is currently unavailable.
          Please contact us at 1-855-880-2559 for assistance.</div>`,
        buttons: []
      });
    } else {
      this.flowManager.isSubmitting = false;
    }
    let errorStatus;
    if (res.errors && res.errors.length) {
      errorStatus = res.errors[0].status;
    }

    if (res.cupid) {
      // success path
      this.appActions.setData('StepCompleted.credentialsSubmitted', true);
      this.modal.closeModal('success');
    } else if (errorStatus === '409') {
      // Username already taken display error message
      this.credError = false;
      this.modal.closeModal('credentials');
    } else {
      // duplicate user details
      this.error = false;
      this.modal.closeModal('credentials');
    }
  }
}
